module.exports = __webpack_public_path__ + "img/img16.c4518b9a.png";